import { render, staticRenderFns } from "./base-date-picker.vue?vue&type=template&id=64db563a&scoped=true"
import script from "./base-date-picker.ts?vue&type=script&lang=ts&external"
export * from "./base-date-picker.ts?vue&type=script&lang=ts&external"
import style0 from "./base-date-picker.vue?vue&type=style&index=0&id=64db563a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db563a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64db563a')) {
      api.createRecord('64db563a', component.options)
    } else {
      api.reload('64db563a', component.options)
    }
    module.hot.accept("./base-date-picker.vue?vue&type=template&id=64db563a&scoped=true", function () {
      api.rerender('64db563a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/DatePicker/base-date-picker.vue"
export default component.exports